
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseDto } from '@models/base/baseDto.model';
import { CreateKeyValueRequest } from '@models/base/createKeyValueRequest.model';
import { CreateResponseBase } from '@models/base/createResponseBase.model';
import { UpdateKeyValueRequest } from '@models/base/updateKeyValueRequest.model';
import { CreateTipoCasoRequest } from '@models/tipoCaso/createTipoCasoRequest.model';
import { UpdateTipoCasoRequest } from '@models/tipoCaso/updateTipoCasoRequest.model';
import { CreateVariableRequest } from '@models/variable/createVariableRequest.model';
import { UpdateVariableRequest } from '@models/variable/updateVariableRequest.model';
import { VariableDto } from '@models/variable/variableDto.model';
import { VariableGroup } from '@models/variable/variableGroup.model';
import { map, Observable, of } from 'rxjs';
import { isFalsy } from 'utility-types';

@Injectable({
  providedIn: 'root'
})
export class VariableService {

  private readonly baseUrl = '/api/Variable';

  constructor(private http: HttpClient) { }

  getAll(): Observable<VariableDto[]> {
    return this.http.get<VariableDto[]>(`${this.baseUrl}/GetAll`);
  }

  getAllGroupedByType(): Observable<VariableGroup[]> {
    return this.getAll().pipe(
      map(variables => {
        const grouped = variables.reduce((acc, variable) => {
          const tipo = variable.tipoVariable?.descripcion || 'Sin Categoría';
          if (!acc[tipo]) {
            acc[tipo] = [];
          }
          acc[tipo].push(variable);
          return acc;
        }, {} as { [key: string]: VariableDto[] });

        return Object.keys(grouped).map(tipoVariable => ({
          tipoVariable,
          variables: grouped[tipoVariable]
        }));
      })
    );
  }

  getById(id: number): Observable<VariableDto> {
    return this.http.get<VariableDto>(`${this.baseUrl}/GetById?id=${id}`);
  }

  create(request: CreateVariableRequest): Observable<VariableDto> {
    return this.http.post<VariableDto>(`${this.baseUrl}/Create`, request);
  }

  update(variable: VariableDto): Observable<VariableDto> {
    return this.http.put<VariableDto>(`${this.baseUrl}/Update`, variable);
  }

  delete(id: number): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/Delete?id=${id}`);
  }

  searchByCodigo(searchTerm: string): Observable<VariableDto[]> {
    return this.getAll().pipe(
      map(variables =>
        variables.filter(v =>
          v.codigo.toLowerCase().includes(searchTerm.toLowerCase())
        )
      )
    );
  }
}
